/* Berry Lemon Cakes: keep the selected option's price next to where the customer is looking.
   - Adds the price to the Add to cart button ("Add to cart · $85").
   - Adds a "Your price" line right under the options.
   - Pulses the button and the price line when the price changes.
   Reads the theme's own price block, so the price shown always matches Shopify's. */
(() => {
  const css = `
.bl-atc-price{font-weight:600;white-space:nowrap}
.bl-live-price{display:flex;justify-content:space-between;align-items:baseline;gap:12px;width:100%;box-sizing:border-box;padding:12px 16px;border-radius:12px;background:#F4E1E5;color:#2B1D24}
.bl-live-price span{font-size:.95rem}
.bl-live-price strong{font-family:var(--font-heading--family);font-weight:500;font-size:1.4rem;color:#A61E47;line-height:1.1}
@media (prefers-reduced-motion:no-preference){
.bl-pulse{animation:blPulse .6s ease}
.bl-flash{animation:blFlash .9s ease}
@keyframes blPulse{0%{transform:scale(1)}40%{transform:scale(1.035)}100%{transform:scale(1)}}
@keyframes blFlash{0%{background:#E7BFCA}100%{background:#F4E1E5}}
}`;
  const st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  const num = (t) => {
    const m = (t || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  };
  const fmt = (n) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: n % 1 ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(n);
  const replay = (el, cls) => {
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  };

  const last = new Map();
  let busy = false;
  function update() {
    busy = true;
    document.querySelectorAll('product-form-component').forEach((form) => {
      if (form.closest('sticky-add-to-cart')) return;
      const scope = form.closest('.shopify-section') || document;
      const priceEl = scope.querySelector('product-price .price');
      const btn = form.querySelector('[ref="addToCartButton"]');
      if (!priceEl || !btn) return;
      const unit = num(priceEl.textContent);
      if (unit == null) return;
      const qty = parseInt((form.querySelector('input[name="quantity"]') || {}).value || '1', 10) || 1;
      const label = fmt(unit * qty);

      // 1. Price inside the Add to cart button
      const host = btn.querySelector('.add-to-cart-text__content') || btn;
      let tag = btn.querySelector('.bl-atc-price');
      if (!tag || !host.contains(tag)) {
        if (tag) tag.remove();
        tag = document.createElement('span');
        tag.className = 'bl-atc-price';
        host.appendChild(tag);
      }
      const key = scope.id || 'page';
      const prev = last.get(key);
      if (tag.textContent !== ' · ' + label) tag.textContent = ' · ' + label;

      // 2. Price line right under the options (products with more than one option)
      const picker = scope.querySelector('variant-picker');
      let line = scope.querySelector('.bl-live-price');
      if (picker && picker.querySelectorAll('input[type="radio"], option').length > 1) {
        if (!line || line.previousElementSibling !== picker) {
          if (line) line.remove();
          line = document.createElement('div');
          line.className = 'bl-live-price';
          line.setAttribute('aria-live', 'polite');
          line.innerHTML = '<span>Your price</span><strong></strong>';
          picker.insertAdjacentElement('afterend', line);
        }
        const strong = line.querySelector('strong');
        if (strong.textContent !== label) strong.textContent = label;
      }

      if (prev !== label) {
        last.set(key, label);
        if (prev !== undefined) {
          replay(btn, 'bl-pulse');
          if (line) replay(line, 'bl-flash');
        }
      }
    });
    busy = false;
  }

  let queued = false;
  const schedule = () => {
    if (busy || queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      update();
    });
  };

  const start = () => {
    update();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', schedule, true);
    document.addEventListener('input', schedule, true);
    document.addEventListener('click', () => setTimeout(schedule, 50), true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();